"use strict";

const { String } = require("../lib/types");

const activelyUsing = "Is the patient actively using?";
const desireToQuit = "Does the patient have a desire to quit?";
const healthEffects = "Does the patient perceive any negative health effects?";
const healthEffectsDetails = "Perceived health effects?";

module.exports = {
  activelyUsing: {
    name: "activelyUsing",
    question: activelyUsing,
    type: String,
    jq: ["contained[0].item[text=?].answer[0].valueString", activelyUsing]
  },
  desireToQuit: {
    name: "desireToQuit",
    question: desireToQuit,
    type: String,
    jq: ["contained[0].item[text=?].answer[0].valueString", desireToQuit]
  },
  healthEffects: {
    name: "healthEffects",
    question: healthEffects,
    type: String,
    jq: ["contained[0].item[text=?].answer[0].valueString", healthEffects]
  },
  healthEffectsDetails: {
    name: "healthEffectsDetails",
    question: "Perceived health effects?",
    type: String,
    jq: [
      "contained[0].item[text=?].answer[0].valueString",
      healthEffectsDetails
    ]
  }
};
